import actionTypes from 'constants/actionTypes'
import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import each from 'lodash/each'

type SelectedMap = Record<string, string>

interface SelectedState {
  nodes: SelectedMap
  edges: SelectedMap
}

interface SelectedAction {
  type?: string
  payload?: {
    id?: string
    ids?: string[]
  }
  previousPayload?: {
    id?: string
    ids?: string[]
  }
}

const initialState: SelectedState = {
  nodes: {},
  edges: {},
}

const selected = (state: SelectedState = initialState, action: SelectedAction): SelectedState => {
  switch (action.type) {
    case actionTypes.GRAPH.SELECTED.DESELECT_ALL:
      return {
        nodes: {},
        edges: {}
      }
    case actionTypes.NODES.MULTI.SELECT: {
      const updated = cloneDeep(state)
      each(action.payload?.ids ?? [], (id: string) => {
        updated.nodes[id] = id
      })
      return updated
    }
    case actionTypes.NODES.ONE.SELECT:
      return defaultsDeep(
        {
          nodes: {
            [action.payload?.id ?? '']: action.payload?.id ?? ''
          }
        },
        state
      )
    case actionTypes.NODES.ONE.DESELECT: {
      const id = action.payload?.id || action.previousPayload?.id
      if (!id) return state
      const updated = cloneDeep(state)
      delete updated.nodes[id]
      return updated
    }
    case actionTypes.EDGES.MULTI.SELECT: {
      const updated = cloneDeep(state)
      each(action.payload?.ids ?? [], (id: string) => {
        updated.edges[id] = id
      })
      return updated
    }
    case actionTypes.EDGES.ONE.SELECT:
      return defaultsDeep(
        {
          edges: {
            [action.payload?.id ?? '']: action.payload?.id ?? ''
          }
        },
        state
      )
    case actionTypes.EDGES.ONE.DESELECT: {
      if (!action.payload?.id) return state
      const updated = cloneDeep(state)
      delete updated.edges[action.payload.id]
      return updated
    }
    case actionTypes.EDGES.ONE.DELETE.REQUEST:
    case actionTypes.EDGES.ONE.DELETE.RECEIVE: {
      const id = action.payload?.id || action.previousPayload?.id
      if (!id) return state
      const updated = cloneDeep(state)
      delete updated.edges[id]
      return updated
    }
    case actionTypes.EDGES.MULTI.DELETE.REQUEST:
    case actionTypes.EDGES.MULTI.DELETE.RECEIVE: {
      const updated = cloneDeep(state)
      const ids = action.payload?.ids || action.previousPayload?.ids || []
      each(ids, (id: string) => {
        delete updated.edges[id]
      })
      return updated
    }
    case actionTypes.NODES.ONE.DELETE.REQUEST:
    case actionTypes.NODES.ONE.DELETE.RECEIVE: {
      const updated = cloneDeep(state)
      const id = action.payload?.id || action.previousPayload?.id
      if (!id) return state
      delete updated.nodes[id]
      return updated
    }
    case actionTypes.NODES.MULTI.DELETE.REQUEST:
    case actionTypes.NODES.MULTI.DELETE.RECEIVE: {
      const updated = cloneDeep(state)
      const ids = action.payload?.ids || action.previousPayload?.ids || []
      each(ids, (id: string) => {
        delete updated.nodes[id]
      })
      return updated
    }
    default:
      return state
  }
}

export default selected
